import React, {useState } from "react";
import { Alert, Col, Row } from "reactstrap";
import HeaderTitle from "../../../../../common/HeaderTitle";
import PopupMsgWrapper from "../../../../../common/PopupMsgWrapper";
import { apiErrors, notify, userDetails } from "../../../../../../helper";
import { useHistory } from "react-router-dom";
import LoaderCustom from "../../../../../common/LoaderCustom";
import axiosHelper from "../../../../../../axiosHelper";
import { API } from "../../../../../../config/constants";

const KYS2FormRequestReview = (props) => {
  let { reviewRequestResponseData } = props;
  const history = useHistory();
  const urlParams = new URLSearchParams(window.location.search);
  const selfAssesmentId = urlParams.get("VendorRequirementRegistrationId");
  const [showPopupForRequestReview, setShowPopupForRequestReview] = useState(false);
  const [showRemarkRequestReviewPopup, setShowRemarkRequestReviewPopup] = useState(false);
  const [remarkRequestReview, setRemarkRequestReview] = useState("");
  const [showTabLoader, setShowTabLoader] = useState(false); // State to manage loading status
  const [remarkError, setRemarkError] = useState(""); // State to manage remark validation error

  const closePopUpForRequestReview = () => {
    setShowPopupForRequestReview(false);
  };

  const onPopupConfirmForRequestReview = () => {
    if (!remarkRequestReview) {
      setRemarkError("Please enter a remark");
      return;
    }
    setShowPopupForRequestReview(true);
    setShowRemarkRequestReviewPopup(false);
  };

  const convertISOToUtcDate1 = (isoDate) => {
    const date = new Date(isoDate);
    // Extract date components
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure month is two digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure day is two digits
    const year = date.getFullYear();
    // Format date as dd/mm/yyyy
    return `${day}/${month}/${year}`;
  };

  const handleSubmitReponse = async (action, workFlowLevel) => {

    if (!remarkRequestReview) {
      return;
    }
    const userDetail = userDetails();
    const reviewRequesterData = {
      Action: action,
      remark: remarkRequestReview,
      WorkflowLevel: workFlowLevel,
      EmployeeId: parseInt(userDetail?.EmployeeId),
      vendorRequirementRegistrationId: selfAssesmentId,
    };
    setShowTabLoader(true)
    setShowRemarkRequestReviewPopup(false);
    setShowPopupForRequestReview(false);
    setRemarkRequestReview("");
    setRemarkError(""); // Reset validation error
    axiosHelper.post(`${API.kys2ApproveRejectRequestReviewResponse}`, reviewRequesterData).then((response) => {
      if (response.data.IsSuccessful) {
        notify.success(response?.data?.Data?.Message);
        setShowTabLoader(false);
        if (props?.viewDataFromSupplier?.IsBlockedVendor) {
          history.push("/supplier-unblocking-request");
        } else {
          history.push("/vendor-need-list");
        }
      }
    }).catch((error) => {
      setShowTabLoader(false);
      setRemarkRequestReview("");
      if (error.response.status === 401) {
        apiErrors(error)
      }else{

        if (!error?.response?.data?.IsSuccessful) {
          notify.error(error?.response?.data?.ErrorMessage)
        }
      }
    });
  };

  return (
    <>
      {showTabLoader && (<LoaderCustom customClass="simulation-Loader" />)}
      <>
        {reviewRequestResponseData && reviewRequestResponseData?.RequestReviews?.length > 0 ? (
          <div className="hl-vendor-approval mt-4">
            {reviewRequestResponseData &&
              reviewRequestResponseData?.RequestReviews?.map((data) => (
                <Row key={data.ReviewRequestId} className="hl-need-form mt-3 align-items-center" >
                  {/* {true ? ( */}
                  {data.Status === 1 ? (
                    <>
                      <Col lg="3">
                        <div className="d-flex align-items-baseline pt-2">
                          <h3 className="">Requested By:</h3>
                          <p className="ms-3">{data.Name}</p>
                        </div>
                      </Col>
                     
                      <Col lg="3">
                        <div className="d-flex align-items-baseline pt-2">
                          <h3 className="">Approver:</h3>
                          <p className="ms-3">{`Level ${data.WorkFlowLevel}`}</p>
                        </div>
                      </Col>
                      <Col md="12"><hr className="hr-seprator mb-2" /></Col>
                      {showPopupForRequestReview && (
                        <PopupMsgWrapper
                          isOpen={showPopupForRequestReview}
                          closePopUp={closePopUpForRequestReview}
                          confirmPopup={() =>
                            handleSubmitReponse("Response", data?.WorkFlowLevel)
                          }
                          message={`Are you sure you want to Request Review?`}
                        />
                      )}
                      {showRemarkRequestReviewPopup && (
                        <PopupMsgWrapper
                          setInputData={(data) => setRemarkRequestReview(data)}
                          isOpen={showRemarkRequestReviewPopup}
                          header={"Submit Response"}
                          closePopUp={() => {
                            setShowRemarkRequestReviewPopup(false)
                            setRemarkRequestReview("")
                          }}
                          confirmPopup={onPopupConfirmForRequestReview}
                          isInputFieldResponse={true} // Assuming you want an input field in your popup
                          validationError={remarkError} // Pass validation error to the popup
                        />
                      )}
                      <div className="review-request mt-3">
                        <div className="remarks-wrap">
                          <HeaderTitle title={"Remarks:"} customClass="" />
                          <p className="para-color">{data.RequestRemark}
                            <strong className="d-block hl-date-remark">
                              {convertISOToUtcDate1(data.RequestDate)}
                            </strong>
                          </p>
                        </div>
                      </div>
                      
                    </>
                  ) : (
                    <>
                      <Col lg="3">
                        <div className="d-flex align-items-baseline pt-2">
                          <h3 className="">Requested By:</h3>
                          <p className="ms-3">{data.Name}</p>
                        </div>
                      </Col>
                      
                      <Col lg="3">
                        <div className="d-flex align-items-baseline pt-2">
                          <h3 className="">Approver:</h3>
                          <p className="ms-3">{"Level " + data?.WorkFlowLevel}</p>
                        </div>
                      </Col>
                      <Col md="12"><hr className="hr-seprator mb-4" /></Col>
                      <div className="review-request">
                        <div className="remarks-wrap">
                          <HeaderTitle title={"Remarks:"} customClass="" />
                          <p className="para-color">{data?.RequestRemark}
                            <strong className="d-block hl-date-remark">
                              {convertISOToUtcDate1(data?.RequestDate)}
                            </strong>
                          </p>
                          <hr className="hr-seprator" />
                        </div>
                        <div className="remarks-wrap ml-4 mt-2">
                          <HeaderTitle title={"Response:"} customClass="" />
                          <p className="para-color">{data?.ResponseRemark}
                            <strong className="d-block hl-date-remark">
                              {convertISOToUtcDate1(data?.ResponseDate)}
                            </strong>
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </Row>
              ))}
          </div>
        ) : (
          <div className="hl-pending-text">
            <Alert color="warning">
              <h2>
                <span className="font-16 d-flex">
                  <i className="fa fa-info-circle mr-2" aria-hidden="true" ></i>
                  <span>No review responses available for the approver.</span>
                </span>
              </h2>
            </Alert>
          </div>
        )}
      </>
    </>
  );
};

export default KYS2FormRequestReview;
